<div [class]="headerCssClass">
  @if ((type === 'primary' || type === 'blue') && icon) {
    <MirIcon>{{icon}}</MirIcon>
  }
  <span>{{title}}</span>
</div>
<div mat-dialog-content>
  <div class="size-full flex flex-col gap-y-2">
    @for (message of messages; track message.id) {
      <div class="font-medium text-base text-carbon last:font-normal last:text-gray-700" [innerHTML]="message.value"></div>
    }
  </div>
  @if (data.fields.length > 0) {
    <form class="prompt-form"
        [formGroup]="promptForm"
        (submit)="handleSubmit()">
      <button class="hidden-submit" type="submit"></button>
      @for (field of data.fields; track field.name;) {
        <mat-form-field class="prompt-form-field">
          <input [type]="field.type ?? 'text'"
              autocomplete="off"
              matInput
              #inputField
              [required]="field.mandatory"
              [id]="getInputId(field.name)"
              [attr.maxlength]="maxLength"
              [formControlName]="field.name"
              [placeholder]="field.name"
              (blur)="handleBlur(field)"
              (input)="handleInput(field)">
          @if (promptForm.controls[field.name].hasError('required')
            && promptForm.controls[field.name].touched) {
            <mat-error>{{ 'UI.MandatoryField' | translate }}</mat-error>
          }
          @if (promptForm.controls[field.name].hasError('pattern')
            && promptForm.controls[field.name].touched) {
            <mat-error>{{ 'Entity.Export.Email.Invalid' | translate }}</mat-error>
          }
          @if (hintLabel) {
            <mat-hint align="end">{{ hintLabel }}</mat-hint>
          }
        </mat-form-field>
      }
    </form>
}
</div>
<div mat-dialog-actions align="end">
  <button mirButton stroked (click)="handleNoClick()">
    @if (type !== 'primary' && type !== 'blue') {
      <MirIcon>cancel</MirIcon>
    }
    {{'UI.Cancel' | translate}}
  </button>

    @switch (type) {
      @case ('primary') {
        <button mirButton primary flat
            mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          {{confirmLabel ?? ('UI.OK' | translate)}}
        </button>
      }
      @case ('accent') {
        <button mirButton stroked accent mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{confirmLabel ?? ('UI.OK' | translate)}}
        </button>
      }
      @case ('warn') {
        <button mirButton stroked warn mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{confirmLabel ?? ('UI.OK' | translate)}}
        </button>
      }
      @case ('danger') {
        <button mirButton stroked warn mat-dialog-close
            class="!text-orange-700 hover:!bg-orange-50 hover:!text-orange-700"
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{confirmLabel ?? ('UI.OK' | translate)}}
        </button>
      }
      @case ('slate') {
        <button mirButton stroked slate mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{confirmLabel ?? ('UI.OK' | translate)}}
        </button>
      }
      @case ('blue') {
        <button mirButton stroked accent
            mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          {{confirmLabel ?? ('UI.OK' | translate)}}
        </button>
      }
      @default {
        <button mirButton stroked mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{confirmLabel ?? ('UI.OK' | translate)}}
        </button>
      }
    }
</div>
